import {useRef, useState} from 'react'
import {
  AdminServiceProviderDTO,
  AdminServiceProviderDTOApiData,
  BooleanApiData,
  GetServiceProviderRequest,
  UpsertServiceProviderRequest,
} from '../../../api/data-contracts'
import {FormikValues} from 'formik'
import _ from 'lodash'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useSelector, useDispatch} from 'react-redux'
import {KTSVG} from '../../../../_metronic/helpers'
import {
  Api_Admin_GetServiceProvider,
  Api_Admin_UpsertServiceProvider,
} from '../../../apiClient/apiClient'
import FormMessage from '../../../components/common/messages/FormMessage'
import FormikForm from '../../../components/form/FormikForm'
import FormInput from '../../../components/form/FormInput'
import {getAdminState} from '../../../redux/adminSlice'
import {setIsLoading, postRequestAsync} from '../../../redux/commonSlice'
import {CanIDoThat} from '../../../utils/CanIDoThat'
import {setFormikStatus} from '../../../utils/utilities'
import * as Yup from 'yup'
import {UserTypeAuthorizationsEnum} from '../../../apiClient/enums'

function AdminReferenceDetailPage(props: {data: AdminServiceProviderDTO; onSaved?: () => void}) {
  const schema = Yup.object().shape({
    firstName: Yup.string().required('AD_REQUIRED'),
    lastName: Yup.string().required('SOYAD_REQUIRED'),
    emailAddress: Yup.string()
      .email('EPOSTA_ADRESI_EPOSTA')
      .min(3, 'EPOSTA_ADRESI_MIN')
      .max(50, 'EPOSTA_ADRESI_MAX')
      .required('EPOSTA_ADRESI_REQUIRED'),
    phoneNumber: Yup.string().required('TELEFON_NUMARASI_REQUIRED'),
    identityNumber: Yup.string().required('TC_KİMLİK_NO_REQUIRED'),
    name: Yup.string().required('FIRMA_ADI_ZORUNLUDUR'),
    legalName: Yup.string().required('YASAL_AD_REQUIRED'),
    iban: Yup.string().required('IBAN_REQUIRED'),
    address: Yup.string().required('ADRES_REQUIRED'),
  })

  const [modalShow, setModalShow] = useState(false)
  const [detail, setDetail] = useState<AdminServiceProviderDTO | null>(null)

  const formikRef = useRef(null)
  const intl = useIntl()
  const dispatch = useDispatch()

  const handleModalClose = () => setModalShow(false)

  const load = async () => {
    const body: GetServiceProviderRequest = {
      guidId: props.data.guidId,
    }
    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_GetServiceProvider,
        body,
      })
    )
      .unwrap()
      .then((response: AdminServiceProviderDTOApiData) => {
        setDetail(response.data ?? null)
        setModalShow(true)
      })
  }

  const initData: UpsertServiceProviderRequest = {
    serviceProviderId: detail?.serviceProviderId ?? props.data.serviceProviderId,
    firstName: detail?.firstName ?? props.data.firstName ?? '',
    lastName: detail?.lastName ?? props.data.lastName ?? '',
    emailAddress: detail?.emailAddress ?? props.data.emailAddress ?? '',
    phoneNumber: detail?.phoneNumber ?? props.data.phoneNumber ?? '',
    identityNumber: detail?.identityNumber ?? props.data.identityNumber ?? '',
    name: detail?.name ?? props.data.name ?? '',
    legalName: detail?.legalName ?? props.data.legalName ?? '',
    subMerchantType: detail?.subMerchantType ?? props.data.subMerchantType ?? '',
    iban: detail?.iban ?? props.data.iban ?? '',
    address: detail?.address ?? props.data.address ?? '',
    taxOffice: detail?.taxOffice ?? props.data.taxOffice ?? '',
    taxNumber: detail?.taxNumber ?? props.data.taxNumber ?? '',
    legalCompanyTitle: detail?.legalCompanyTitle ?? props.data.legalCompanyTitle ?? '',
    password: '',
  }

  const submit = async (values: UpsertServiceProviderRequest, actions: FormikValues) => {
    dispatch(setIsLoading(true))
    const body: UpsertServiceProviderRequest = {
      serviceProviderId: values.serviceProviderId,
      firstName: values.firstName,
      lastName: values.lastName,
      emailAddress: values.emailAddress,
      phoneNumber: values.phoneNumber,
      identityNumber: values.identityNumber,
      name: values.name,
      legalName: values.legalName,
      subMerchantType: values.subMerchantType,
      iban: values.iban,
      address: values.address,
      taxOffice: values.taxOffice,
      taxNumber: values.taxNumber,
      legalCompanyTitle: values.legalCompanyTitle,
    }

    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_UpsertServiceProvider,
        body,
      })
    )
      .unwrap()
      .then(async (response: BooleanApiData) => {
        setFormikStatus(actions, response)
        if (response.data && props.onSaved) {
          props.onSaved()
        }
      })
  }

  return (
    <>
      <a
        href='#'
        onClick={() => {
          load()
        }}
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
      >
        <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3' />
      </a>

      <Modal size='xl' show={modalShow} onHide={handleModalClose} centered id='kt_modal_success'>
        <Modal.Header closeButton>
          <h5 className='modal-title'>{props?.data?.name} Bilgileri</h5>
        </Modal.Header>
        <Modal.Body>
          <FormikForm
            initialValues={initData}
            onSubmit={submit}
            innerRef={formikRef}
            validationSchema={schema}
          >
            {(formProps) => {
              return (
                <>
                  <div className='w-100 mt-5'>
                    <div className='row mb-7'>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>Ad</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'firstName', placeholder: ''}}
                          istouched={formProps.touched.firstName ?? false}
                          errorMessage={formProps.errors.firstName}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>Soyad</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'lastName', placeholder: ''}}
                          istouched={formProps.touched.lastName ?? false}
                          errorMessage={formProps.errors.lastName}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                    </div>

                    <div className='separator border-3 my-3 mx-1'></div>

                    <div className='row mb-7'>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>E-Posta</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'emailAddress', placeholder: ''}}
                          istouched={formProps.touched.emailAddress ?? false}
                          errorMessage={formProps.errors.emailAddress}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>Telefon</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'phoneNumber', placeholder: ''}}
                          istouched={formProps.touched.phoneNumber ?? false}
                          errorMessage={formProps.errors.phoneNumber}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                    </div>

                    <div className='separator border-3 my-3 mx-1'></div>

                    <div className='row mb-7'>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>Firma Adı</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'name', placeholder: ''}}
                          istouched={formProps.touched.name ?? false}
                          errorMessage={formProps.errors.name}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>Yasal Ad</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'legalName', placeholder: ''}}
                          istouched={formProps.touched.legalName ?? false}
                          errorMessage={formProps.errors.legalName}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                    </div>

                    <div className='separator border-3 my-3 mx-1'></div>

                    <div className='row mb-7'>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>TC Kimlik No</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'identityNumber', placeholder: ''}}
                          istouched={formProps.touched.identityNumber ?? false}
                          errorMessage={formProps.errors.identityNumber}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>IBAN</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'iban', placeholder: ''}}
                          istouched={formProps.touched.iban ?? false}
                          errorMessage={formProps.errors.iban}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                    </div>

                    <div className='separator border-3 my-3 mx-1'></div>

                    <div className='row mb-7'>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>Vergi Dairesi</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'taxOffice', placeholder: ''}}
                          istouched={formProps.touched.taxOffice ?? false}
                          errorMessage={formProps.errors.taxOffice}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>Vergi No</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'taxNumber', placeholder: ''}}
                          istouched={formProps.touched.taxNumber ?? false}
                          errorMessage={formProps.errors.taxNumber}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                    </div>

                    <div className='separator border-3 my-3 mx-1'></div>

                    <div className='row mb-7'>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>Yasal Şirket Ünvanı</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'legalCompanyTitle', placeholder: ''}}
                          istouched={formProps.touched.legalCompanyTitle ?? false}
                          errorMessage={formProps.errors.legalCompanyTitle}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                      <div className='col-lg-2 d-flex align-items-center'>
                        <label className='fw-bold text-muted'>Adres</label>
                      </div>
                      <div className='col-lg-4'>
                        <FormInput
                          fieldAttributes={{type: 'text', name: 'address', placeholder: ''}}
                          istouched={formProps.touched.address ?? false}
                          errorMessage={formProps.errors.address}
                          placeHolderOnTop={false}
                          checkValid={false}
                        />
                      </div>
                    </div>

                    <div className='separator border-3 my-3 mx-1'></div>

                    <div className='row'>
                      <div className='col-lg-6 offset-3'>
                        <FormMessage {...formProps.status} />
                      </div>
                    </div>

                    {CanIDoThat(UserTypeAuthorizationsEnum.Admin_Panel_Company_Update) && (
                      <div className='d-flex'>
                        <div className='ms-auto p-2'>
                          <button type='submit' className='btn btn-lg btn-primary mt-2'>
                            <span className='indicator-label'>Kaydet</span>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )
            }}
          </FormikForm>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default AdminReferenceDetailPage
